export default "__VITE_ASSET__CSmgrJHe__"